export default "__VITE_ASSET__DD64$oWN__"